import { Chip } from "@mui/material";
import * as strings from "common/strings";
import * as config from "config";
import { useLocation } from "react-router-dom";
import { useConfigQuery } from "services/staticDataService";

const WorkspaceBadge = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const { data: generalConfiguration } = useConfigQuery(
    "general_configuration",
    {
      skip: isAdmin,
    }
  );

  const name =
    generalConfiguration?.workspace?.name ??
    (isAdmin ? strings.toSentenceCase(config.ENVIRONMENT) : null);

  if (!name) return null;

  return (
    <Chip
      className={"fade-in-slow"}
      label={name}
      variant={"outlined"}
      size={"small"}
      sx={{ fontWeight: 500 }}
    />
  );
};

export default WorkspaceBadge;
